import { FC } from "react"
import {
  PuxFab,
  PuxFabButton,
  PuxIcon,
  PuxSimcard,
  PuxText,
  PuxTypography,
  useTranslation,
} from "@phonero/pux-react"
import { approved, plus } from "@phonero/pux-icons/icons"
import { OrderBadge } from "../Other/OrderBadge"
import vippsLogo from "../assets/svgs/icon/VippsLogoWhite.svg"

export const SimCardWithOrderButton: FC<{
  card: any
  setOrderSim: any
  availableToOrder?: number
  disabled?: boolean
  //Hack: For some reason styling is different between DP and DB
  dittPhonero?: boolean
  payByVipps?: boolean
}> = ({ card, setOrderSim, availableToOrder, disabled, dittPhonero, payByVipps }) => {
  const { t, i18n } = useTranslation()

  const isFree = !card?.price
  return (
    <PuxSimcard
      style={{ outlineStyle: "none", ...(disabled && { opacity: "0.5" }) }}
      price={i18n.format(Number(card?.price), "price")}
      fill="outline"
    >
      <PuxTypography slot="name" variant={"label"} component={"span"}>
        {t("AddSubscriptionWizard.Step4.OrderNewOfType", {
          cardtype: t(card.name),
        })}
        <br />
      </PuxTypography>
      <i slot="name">
        {!!availableToOrder && (
          <PuxTypography variant={"info-small"} component={"span"}>
            {t("SimCard.Available", {
              count: availableToOrder,
            })}
          </PuxTypography>
        )}
      </i>
      <PuxText slot="price" />
      {/* TODO: Add VIPPS icon below */}
      {payByVipps ? (
        <>
          <PuxText
            style={{ fontWeight: "normal", "--pux-color-contrast": "white" }}
            slot="billing"
          >
            <img src={vippsLogo} alt="Vipps logo" width="50" height="20" />
          </PuxText>
        </>
      ) : (
        <>
          <PuxText
            style={{ fontWeight: "normal", "--pux-color-contrast": "white" }}
            slot="billing"
          >
            pr.mnd
          </PuxText>
          <PuxText
            style={{ fontWeight: "normal", "--pux-color-contrast": "white" }}
            slot="vat"
          >
            {t("ExVat")}
          </PuxText>
        </>
      )}
      <PuxFab
        slot="fixed"
        vertical="center"
        horizontal="center"
        style={
          !dittPhonero
            ? { transform: "translateY(5px)" }
            : { transform: "translateY(95px)" }
        }
      >
        <PuxFabButton
          disabled={disabled}
          color="primary"
          style={{
            ...(isFree && {
              "--pux-color-primary": "var(--pux-color-success)",
            }),
            ...(payByVipps && { "--pux-color-primary": "#FF5B24" }),
          }}
          onClick={() => setOrderSim(card)}
        >
          <PuxIcon
            icon={plus}
            style={!dittPhonero ? { marginLeft: "5px" } : { marginLeft: "0px" }}
          />
        </PuxFabButton>
      </PuxFab>
      {isFree && (
        <div slot={"fixed"} style={{ right: "35%", bottom: -15 }}>
          <OrderBadge
            icon={approved}
            color={"green"}
            text={t("Free")}
            size={"small"}
          />
        </div>
      )}
      {disabled && (
        <PuxTypography
          slot="fixed"
          variant={"info-small"}
          style={{ bottom: "5%", left: "5%" }}
        >
          Kan ikke kombineres med SMS-opptak
        </PuxTypography>
      )}
    </PuxSimcard>
  )
}
